import { render, staticRenderFns } from "./TenantUsuarioLogadoListNovo.vue?vue&type=template&id=30a33fb2&lang=html"
import script from "./TenantUsuarioLogadoListNovo.vue?vue&type=script&lang=js"
export * from "./TenantUsuarioLogadoListNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports